export default [
  {
    path: '',
    name: 'payment method edc list',
    component: () => import('@/views/app/payment-method-edc/list/page-list.vue'),
    meta: { title: 'Daftar Mesin EDC' },
  },
]
